import { useSiteSettings } from "../lib/settings";
import { SITE } from "../lib/site";

/** Public maintenance page — shown to all non-admin visitors when
 * `settings.maintenance_enabled` is true. */
export default function Maintenance() {
  const { settings } = useSiteSettings();
  const title = settings?.maintenance_title || "Site en cours de construction";
  const message = settings?.maintenance_message || "Nous préparons quelque chose de grand. Le site sera bientôt en ligne.";
  const contact = settings?.maintenance_contact || "";
  const phone = settings?.phone || SITE.contact.phone;
  const email = settings?.email || SITE.contact.email;

  return (
    <div data-testid="maintenance-page" className="min-h-screen bg-black text-white flex flex-col items-center justify-center px-6 py-16 relative overflow-hidden">
      {/* subtle radial glow */}
      <div
        className="absolute inset-0 opacity-40 pointer-events-none"
        style={{ background: "radial-gradient(circle at 50% 30%, rgba(230,0,0,0.18) 0%, rgba(0,0,0,0) 60%)" }}
      />

      <div className="relative z-10 max-w-2xl w-full text-center flex flex-col items-center">
        <img
          src="/logo-dark.png"
          alt="ECO-GEST PATRIMOINE"
          className="w-56 md:w-72 lg:w-80 mb-12 animate-fade-in"
        />

        <div className="inline-flex items-center gap-2 px-4 py-1.5 border border-white/20 bg-white/5 backdrop-blur text-[10px] tracking-[0.35em] uppercase mb-6">
          <span className="inline-block w-1.5 h-1.5 rounded-full bg-[#E60000] animate-pulse" />
          En construction
        </div>

        <h1 className="font-display text-3xl md:text-5xl lg:text-6xl font-bold tracking-tight leading-[1.05] mb-6">
          {title}<span className="text-[#E60000]">.</span>
        </h1>

        <p className="text-base md:text-lg text-white/70 leading-relaxed max-w-xl mb-10">
          {message}
        </p>

        {contact && (
          <p className="text-sm text-white/50 leading-relaxed max-w-xl mb-10">
            {contact}
          </p>
        )}

        <div className="flex flex-col sm:flex-row gap-4 w-full sm:w-auto">
          {phone && (
            <a
              data-testid="maintenance-phone"
              href={`tel:${phone.replace(/\s/g, "")}`}
              className="inline-flex items-center justify-center gap-3 bg-[#E60000] hover:bg-[#B30000] text-white px-7 py-4 text-sm font-semibold tracking-wide uppercase transition-colors"
            >
              {phone}
            </a>
          )}
          {email && (
            <a
              data-testid="maintenance-email"
              href={`mailto:${email}`}
              className="inline-flex items-center justify-center gap-3 border border-white/30 hover:border-white text-white hover:bg-white hover:text-black px-7 py-4 text-sm font-semibold tracking-wide uppercase transition-colors"
            >
              {email}
            </a>
          )}
        </div>

        <div className="mt-16 text-[10px] tracking-[0.3em] uppercase text-white/30">
          © {new Date().getFullYear()} {SITE.legalName}
        </div>
      </div>
    </div>
  );
}
